module.exports = __webpack_public_path__ + "static/img/dutyzero.2bd9cbc4.png";